import { graphql } from '../../../../graphql/generated';

export const CREATE_PARAMETER_MUTATION = graphql(`
  mutation CreateParameter($input: ParameterCreateInput!) {
    createParameter(input: $input) {
      id
    }
  }
`);
